import React, { useRef } from "react";
import { useLocation } from "react-router-dom";
import AgentWantAdForm from "../components/AgentWantAdForm";
import Loader from "../components/Common/Loader";
import { AGENT_WANTAD_KEY } from "@/constants/common";
import { getLocalStorage } from "@/helpers/common";
import { startFromId, useStartFromWantAd } from "@/hooks/useStartFromWantAd";

const AgentCreateWantAd = () => {
  const location = useLocation();
  const sourceId = location.state?.data ? null : startFromId(location.search);
  const startFrom = useStartFromWantAd(sourceId);

  // "Start listing" on a saved-search card navigates to this same route with
  // a new import in location.state, and the form only reads initialData when
  // it mounts — so remount it for each *new* import. Not keyed on
  // location.key: the post-save history `replace` that clears the prefill
  // also gets a new key, and remounting then drops the just-created wantAdId
  // (so the next autosave creates a second want-ad).
  const importId = location.state?.data?.pendingImportId ?? null;
  const formKey = useRef({ importId: null, count: 0 });
  if (importId && importId !== formKey.current.importId) {
    formKey.current = { importId, count: formKey.current.count + 1 };
  }

  if (sourceId && startFrom.isPending) {
    return <Loader />;
  }

  const initialData =
    location.state?.data ||
    // A requested copy that failed opens an empty form, not an unrelated
    // draft left in localStorage.
    (sourceId ? startFrom.data : getLocalStorage(AGENT_WANTAD_KEY));

  const isFromConfirmationPage =
    location.state?.isFromConfirmationPage === true;

  const isEdit = isFromConfirmationPage
    ? true
    : location.state?.data
      ? location.state.data.isEdit !== false
      : false;

  return (
    <AgentWantAdForm
      key={formKey.current.count}
      initialData={initialData}
      isEdit={isEdit}
    />
  );
};

export default AgentCreateWantAd;
